import { render } from "./LogoutBox.vue?vue&type=template&id=3151dc5e&scoped=true"
import script from "./LogoutBox.vue?vue&type=script&lang=js"
export * from "./LogoutBox.vue?vue&type=script&lang=js"

import "./LogoutBox.vue?vue&type=style&index=0&id=3151dc5e&scoped=true&lang=css"

import exportComponent from "F:\\XAMPP_NEW\\htdocs\\ASRHAVELI\\delivery\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3151dc5e"]])

export default __exports__